import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  TextField,
  Button,
  Grid,
  Paper,
  IconButton,
  styled,
} from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import { GREEN_LOGO, GREEN_MAIN, WHITE } from '../theme/colors';
import { useTranslationContext } from '../hooks/translations/translationsProvider';
import settings from '../utilities/settings';
import { useWaiter } from '../hooks/waiter/WaiterProvider';
import { delay } from '../utilities/delay';
import { dashboard } from '../hooks/actions/dashboard';
import { useWeb3Context } from '@w3connector/web3provider';
import { validateAddress } from '../helpers/ethers';
import { IWithdrawTokensRequest, IWithdrawResponseModel, WithdrawTokensType } from '../models/withdraw';
import { withdrawRequest } from '../hooks/actions/withdraw';
import WithdrawResponse from './Withdraw/WithDrawResponse';
import CheckBoxTermsAndConditions from './CheckBoxTermsAndConditions';
import { Trans } from 'react-i18next';
import { abbreviaStringa } from '../helpers/cutAddress';
import { ethers } from 'ethers';
import { removeDatabaseWalletConnect } from '../helpers/localStorage';
import assoAbi from "../config/ABI/tokenAbi.json";

const FormCustom = styled('form')(({theme})=>({
    width:'100%',                                      
    [theme.breakpoints.up('md')]: {
        width:'80%',
    },
}))

const ResponseBox = styled(Box)(({theme})=>({
    width:'100%',
    marginTop:"30px",                                      
    [theme.breakpoints.up('md')]: {
        width:'80%',
    },
}))

interface WithdrawFormProps {
    setStatus: (status: boolean) => void;//React.Dispatch<React.SetStateAction<boolean>>;
    status: boolean;
};

const WithdrawMetamaskForm: React.FC<WithdrawFormProps> = ({setStatus, status}) => {
    const [response, setResponse] = useState<IWithdrawResponseModel | null>(null);
    const {t} = useTranslationContext();
    const {  
        web3Hooks,
        chainName,
        setModalOpen,
        handleDisconnect } = useWeb3Context();
    const [amountAvaiable, setAmountAvaible] = useState<number>(0);

    const [amount, setAmount] = useState('');
    const [errorAmount, setErrorAmount] = useState(false);
    const [errorAmountMessage, setErrorAmountMessage] = useState('')

    const [address, setAddress] = useState('');
    const [errorAddress, setErrorAddress] = useState(false);
    const [errorAddressMessage, setErrorAddressMessage] = useState('')

    const [isSended, setIsSended] = useState(false);
    const [mainErrorMex, setMainErrorMex]=useState<string | null>(null);

    
    const [balanceTokenWallet, setBalanceTokenWallet] = useState<string>("");

    const {setWaiterView} = useWaiter();

    const [isChecked, setIsChecked] = useState(true); 

    useEffect(()=>{
        setWaiterView(true)
        delay(500).finally(()=>{
            dashboard()
                .then(resp => {
                    setAmountAvaible(resp.balance)
                })
                .catch(error => {
                    // initLoad.current = false
                    console.log(error)
                })
            setWaiterView(false)
        })
    },[])

    async function getContractBalanceFormatted(): Promise<string | null> {
        if (!web3Hooks.provider || !web3Hooks.account) {
          console.error("Provider o account non disponibile");
          return null;
        }
        try {
          const tokenContract = new ethers.Contract(
            settings.Token.AssoContract,
            assoAbi,
            web3Hooks.provider
          );
      
          const balanceRaw = await tokenContract.balanceOf(web3Hooks.account);
          const decimals = await tokenContract.decimals();
      
          const balanceFormatted = Number(
            ethers.utils.formatUnits(balanceRaw, decimals)
          ).toFixed(2);
      
          return balanceFormatted;
        } catch (err) {
          console.error("Errore nel recuperare il balance del token:", err);
          return "0.00";
        }
      }

    useEffect(() => {
        async function fetchBalance() {
        const value = await getContractBalanceFormatted();
        if (value) setBalanceTokenWallet(value);
        }

        fetchBalance();
    }, [address, web3Hooks, web3Hooks.chainId, chainName]);

    useEffect(()=>{
        if(web3Hooks && web3Hooks.account)
        {
            setAddress(web3Hooks.account)
        }
    },[web3Hooks.account, web3Hooks.chainId])

    const handleInputAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        
        setErrorAmount(false);
        setErrorAmountMessage('');
        const value = e.target.value;
        const regex = /^\d*\.?\d{0,2}$/;

        if(value === ''){
            setAmount('');
            setErrorAmount(false);
            return;
        }

        if (value.includes('.')) {
            const [integerPart, decimalPart] = value.split('.');
            if (decimalPart.length > 2) {
                setErrorAmount(false);
                return;
            }
        }

        if(!regex.test(value)){
            setErrorAmountMessage(t("Inserisci un importo valido"))
            setErrorAmount(true)
        }

        if (parseFloat(value) > 0) {
            if(parseFloat(value) > amountAvaiable){
                setAmount(amountAvaiable.toFixed(2))
                return;
            }
            setAmount(value);
            setErrorAmount(false);
            
        } else {
            setErrorAmountMessage(t("Devi prelevare minimo: ") + parseFloat(settings.WithdrawTokens.MinAmount).toFixed(2) + " ASSO")
            setErrorAmount(true);
            return;
        }
    };

    const handleInputAddressChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        
        setErrorAddress(false);
        setErrorAddressMessage('');
        const value = e.target.value;
        const regex = /^[a-zA-Z0-9]*$/;

        if(value === ''){
            setAddress('');
            setErrorAddress(false);
            return;
        }
        if(!regex.test(value)){
            setErrorAddressMessage(t("Inserisci solo lettere e numeri"))
            setErrorAddress(true)
            return;
        }
        setAddress(value);
        setErrorAddress(false);
    };

    const handleBlurAmount = () => {
        if (!errorAmount && amount) {
            if(parseFloat(amount) < parseFloat(settings.WithdrawTokens.MinAmount))
            {
                setErrorAmountMessage(t("Devi prelevare minimo: ") + parseFloat(settings.WithdrawTokens.MinAmount).toFixed(2) + " Asso")
                setErrorAmount(true);
                setAmount('');
                return;
            }
            const newAmount = parseFloat(amount).toFixed(2)
            setAmount(newAmount);
            setErrorAmount(false);
        }
    };

    const handleBlurAddress = () => {
        if (address!=='') {
            
            if(!validateAddress(address)){
                setErrorAddress(true);
                setErrorAddressMessage("L'indirizzo del wallet che hai inserito non è corretto!");
            }else{
                setErrorAddress(false);
                setErrorAddressMessage('');
            }
                
        }
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        
        if(!errorAmount && !errorAddress && address !== '' && parseFloat(amount) >= parseFloat(settings.WithdrawTokens.MinAmount) && validateAddress(address) && isChecked)
        {   
            setIsSended(true);
            setMainErrorMex(null);
            setWaiterView(true);
            const newReq:IWithdrawTokensRequest = {
                amount: parseFloat(amount),
                address: address,
                acceptTerms: isChecked,
                type: WithdrawTokensType.Wallet // 0 = Wallet
            }
            try{
                const withdraw = await withdrawRequest(newReq)
                setResponse(withdraw);
            }catch(e:any){
                console.log(e);
                setResponse(null);
                setMainErrorMex(e?.data || "Errore durante il prelievo")
                setIsSended(false);
            }
            setWaiterView(false);
        }
        setStatus(!status); // reload delle ultime transazioni
    };


    return (
        <Box sx={{width:'100%', overflow: 'hidden', maxWidth: '100%', fontFamily:'poppins'}}>
            <Paper sx={{ 
                width: '100%', 
                display: 'flex', 
                minHeight:'350px', 
                border: 1, 
                borderColor: 'transparent', 
                overflow: 'hidden',
                maxWidth: '100%', // Limita la larghezza massima del Paper
                boxSizing: 'border-box',
            }}>
                
                <Box sx={{ flexGrow: 1, p: 3, position: 'relative' }}>
                    {response && (
                        <IconButton
                            onClick={() => window.print()}
                            sx={{ position: 'absolute', top: 16, right: 16 }}
                        >
                            <PrintIcon />
                        </IconButton>
                    )}

                    <Card sx={{ backgroundColor: 'transparent', boxShadow: 'none' }}>
                        <CardContent 
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                //padding: '24px 0 0 0',
                                flexDirection: 'column',
                                maxWidth: '100%', // Limita il contenuto a non superare il suo contenitore
                                boxSizing: 'border-box',
                        }}>
                            {/* <Typography variant="h4" gutterBottom  color={BLACK} >
                                {t("Preleva Asso")}
                            </Typography> */}

                            { !response &&
                                <FormCustom onSubmit={handleSubmit}>
                                    <Grid container spacing={2} justifyContent={'center'} sx={{maxWidth: '100%', boxSizing: 'border-box' }}>
                                        {web3Hooks && web3Hooks.isActive ?
                                            <>
                                                <Grid item xs={10} sm={8} justifyItems='center'>
                                                    {/** SEZIONE METAMASK ADDRESS -LOGO- DISCONNESSIONE */}
                                                    <Grid container spacing={1} justifyContent='center'>
                                                        <Grid item xs={12} sm='auto' padding={1} alignContent='center' marginBottom='-5px'>
                                                            <img src='/metamask.png' width='30px'/>
                                                        </Grid>
                                                        <Grid item xs={12} sm='auto' padding={1} alignContent='center'>
                                                            <Typography
                                                                sx={{fontSize:'10px'}}
                                                            >
                                                                {t("Collegato Metamask ")} {abbreviaStringa(web3Hooks.account)}
                                                            </Typography>
                                                             
                                                        </Grid>
                                                        {
                                                            web3Hooks.isActive && chainName !== settings.Token.Blockchain.ChainName &&
                                                            <Grid item xs={12} sm='auto' padding={1} alignContent='center'>
                                                                <Typography
                                                                    sx={{fontSize:'10px', color: 'red'}}
                                                                >
                                                                    {t("Attenzione! Hai selezionato una blockchain sbagliata")}
                                                                </Typography>
                                                            </Grid>
                                                        }
                                                    </Grid> 
                                                    <Button 
                                                        onClick={() => {
                                                            
                                                            removeDatabaseWalletConnect();
                                                            handleDisconnect();
                                                        }}
                                                        variant="contained"
                                                        sx={{
                                                            fontSize:"9px", 
                                                            width:'130px', 
                                                            color:WHITE, 
                                                            marginBottom:8,
                                                            backgroundColor: GREEN_LOGO,
                                                            '&:hover':{
                                                                backgroundColor:'darkgreen'
                                                            }
                                                        }}>
                                                            {t("Disconnetti Wallet")}
                                                    </Button>

                                                    {/** SEZIONE Saldo Attuale */}
                                                    <Grid container xs={12}spacing={1} paddingBottom={8}>
                                                        <Grid item xs={12} alignContent='center' paddingBottom={2}>
                                                            <Typography 
                                                                sx={{
                                                                    fontSize:'12px',
                                                                    fontWeight:'bold'
                                                                }}
                                                            >
                                                                {t("Il tuo saldo attuale ASSO è di")}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6} alignContent='center'>
                                                            <Box 
                                                                sx={{
                                                                    backgroundColor:`${GREEN_LOGO}20`,
                                                                    borderRadius:'5px',
                                                                    minHeight:'80px',
                                                                    alignContent:'center'
                                                                }}
                                                            >
                                                                <Typography
                                                                    sx={{
                                                                        fontSize:'10px',
                                                                        padding:1
                                                                }}>
                                                                    {t("conto")}
                                                                </Typography>
                                                                <Typography
                                                                    sx={{
                                                                        fontSize:'18px',
                                                                        padding:1,
                                                                        fontWeight:'bold'
                                                                }}>
                                                                    {amountAvaiable.toFixed(2)}
                                                                </Typography>
                                                                
                                                            </Box>
                                                            
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} alignContent='center'>
                                                        <Box 
                                                                sx={{
                                                                    backgroundColor:`${GREEN_LOGO}20`,
                                                                    borderRadius:'5px',
                                                                    minHeight:'80px',
                                                                    alignContent:'center'
                                                                }}
                                                            >
                                                                <Typography
                                                                    sx={{
                                                                        fontSize:'10px',
                                                                        padding:1
                                                                }}>
                                                                    {t("portafogli elettronico")}
                                                                </Typography>
                                                                <Typography
                                                                    sx={{
                                                                        fontSize:'18px',
                                                                        padding:1,
                                                                        fontWeight:'bold'
                                                                }}>
                                                                    {balanceTokenWallet}
                                                                </Typography>
                                                                
                                                            </Box>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid container xs={12} spacing={1} justifyContent='center'>
                                                        <Grid item xs={12} alignContent='center' paddingBottom={5}>
                                                            <Typography 
                                                                sx={{
                                                                    fontSize:'12px',
                                                                }}
                                                            >
                                                                {t("Vuoi prelevare ASSO e trasferirli sul tuo portafogli elettronico?")}
                                                            </Typography>
                                                            <Typography 
                                                                sx={{
                                                                    fontSize:'12px',
                                                                }}
                                                            >
                                                                {t("Inserisci qui sotto la quantità di ASSO che desideri prelevare")}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} alignContent='center' paddingBottom={5}>
                                                            <TextField
                                                                fullWidth
                                                                label={t("Quantità ASSO")}
                                                                name="amount"
                                                                onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {(handleInputAmountChange(evt))}}
                                                                onClick={() => {
                                                                    setAmount('')
                                                                    setErrorAmount(false)
                                                                }}
                                                                onBlur={() => handleBlurAmount()}
                                                                value={amount}
                                                                error={errorAmount}
                                                                // disabled={response.success!}
                                                                helperText={
                                                                    errorAmount ? errorAmountMessage : ""
                                                                }
                                                                sx={{
                                                                    '& .MuiOutlinedInput-notchedOutline':{
                                                                        borderColor: GREEN_LOGO,
                                                                        color: GREEN_MAIN,
                                                                    },
                                                                    '& .MuiInputLabel-root':{
                                                                        top:-4,
                                                                        fontSize:'1rem',
                                                                        color: GREEN_MAIN,
                                                                    },
                                                                    '& .MuiInputLabel-root.Mui-focused':{
                                                                        color: GREEN_MAIN
                                                                    },
                                                                    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                                        borderColor: GREEN_LOGO,
                                                                        color: GREEN_MAIN,
                                                                    },
                                                                    '& .MuiOutlinedInput-input': {
                                                                        padding: '12px 12px',
                                                                        lineHeight: 1.4, 
                                                                        color:"grey", fontSize:'1rem',  
                                                                    },
                                                                }}
                                                            />
                                                        </Grid>

                                                        {/**
                                                            <Grid item xs={12} alignContent='center' paddingBottom={5}>
                                                                <CheckBoxTermsAndConditions isChecked={isChecked} setIsChecked={setIsChecked}/>
                                                            </Grid>
                                                        */}

                                                        {address !== '' && parseFloat(amount) >= parseFloat(settings.WithdrawTokens.MinAmount) && 
                                                            <>
                                                                <Grid item xs={12} alignContent='center' paddingBottom={5}>
                                                                    <Typography color={GREEN_MAIN} textAlign={"center"} sx={{fontSize:"0.8rem"}}>
                                                                        {t("L'indirizzo a cui vuoi inviare i fondi è: ")}
                                                                        <strong>{address}</strong>
                                                                    </Typography>
                                                                </Grid>
                                                            </>
                                                        }
                                                        
                                                        <Grid item xs={6} sm={3} alignContent='center' paddingBottom={5}>
                                                            <Button 
                                                                type="submit" 
                                                                variant="contained" 
                                                                disabled={isSended || amount === '' || errorAmount || errorAddress || !validateAddress(address) || !isChecked} 
                                                                sx={{
                                                                    color:WHITE, 
                                                                    border:'0',
                                                                    backgroundColor: GREEN_LOGO,
                                                                    '&:hover':{
                                                                        backgroundColor:'darkgreen'
                                                                    }
                                                                }}>
                                                                {t("Invia")}
                                                            </Button>
                                                        </Grid>

                                                    </Grid>{/** CONTAINER */}
                                                </Grid>
                                            </>
                                            :
                                            <>
                                                {/** WALLET SCONNESSO */}
                                                <Grid item xs={7} sm='auto' justifyItems='center'>
                                                    <Grid container spacing={0}>
                                                        <Grid item xs={12} sm='auto' padding={1}>
                                                            <img src='/metamask.png' width='30px'/>
                                                        </Grid>
                                                        <Grid item xs={12} sm='auto' padding={1}>
                                                            <Typography
                                                                sx={{fontSize:'10px'}}
                                                            >
                                                                <Trans
                                                                    i18nKey="preleva-asso-scollegato-collega"
                                                                    components={{
                                                                        collega: (
                                                                        <a
                                                                            href="#"
                                                                            onClick={(e) => {
                                                                                removeDatabaseWalletConnect();
                                                                                e.preventDefault();
                                                                                if (web3Hooks && web3Hooks.isActive) {
                                                                                    setAddress(web3Hooks.account!);
                                                                                    setErrorAddress(false);
                                                                                    setErrorAddressMessage('');
                                                                                } else {
                                                                                    setModalOpen(true);
                                                                                }
                                                                            }}
                                                                            rel="noopener noreferrer"
                                                                        />
                                                                        ),
                                                                    }}
                                                                    />
                                                            </Typography>
                                                            <Typography
                                                                sx={{fontSize:'10px'}}
                                                            >
                                                                <Trans i18nKey='preleva-asso-scollegato-istruzioni' components={{
                                                                    istruzioni: <a href={`${settings.InfosWebsite.Url}/scarica-portafogli`} target="_blank" rel="noopener noreferrer" />,
                                                                }} />
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                    {/* <Typography color={GRAY_MAIN} textAlign={'left'} mb={2} sx={{fontSize:"0.8rem"}}>
                                                    🔴 <strong>{t("Il tuo wallet è disconnesso")}</strong>
                                                    </Typography> */}
                                                </Grid>
                                            </>
                                        }
                                        {
                                            mainErrorMex && <Grid item xs={12}>
                                                <Typography fontSize="0.75rem" color="red" >
                                                    {mainErrorMex}
                                                </Typography>
                                            </Grid>
                                        }

                                    </Grid>
                                </FormCustom>
                            }

                            { response && 
                                <ResponseBox> 
                                    {
                                        <WithdrawResponse response={response} type={WithdrawTokensType.Wallet} />
                                    }
                                </ResponseBox> 
                            }
                        </CardContent>
                    </Card>
                </Box>
            </Paper>
        </Box>
    );
};

export default WithdrawMetamaskForm;
